import { Dialog, Layout, Text } from '@loadsmart/loadsmart-ui'

import { type Stop, getDelivery, getPickup } from 'core/domain/Stop'
import { formatDescriptionWithZip } from 'core/presenters/stopPresenter'
import { Icon } from 'core/ui/components/icon/Icon'

import { type QuoteAccessorial, type AccessorialCharge } from '../domain/QuoteAccessorial'
import { QuoteSubmitSubTotal } from './QuoteSubmitSubTotal'

export type ConfirmSubmissionDialogProps = {
  flatRate: number
  stops: Array<Stop>
  accessorialCharges?: Array<AccessorialCharge>
  quoteAccessorials?: Array<QuoteAccessorial>
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmSubmissionDialog({
  flatRate,
  stops,
  accessorialCharges = [],
  quoteAccessorials,
  onConfirm,
  onCancel,
}: ConfirmSubmissionDialogProps) {
  const pickup = formatDescriptionWithZip(getPickup(stops))
  const delivery = formatDescriptionWithZip(getDelivery(stops))
  const alignContent = accessorialCharges.length > 0 ? 'flex-start' : 'center'

  return (
    <Dialog onOverlayClick={onCancel} scale="small" open>
      <Dialog.Header>Submit rate</Dialog.Header>
      <Dialog.Body style={{ maxHeight: '560px', overflowX: 'auto' }}>
        <Layout.Stack align={alignContent}>
          <Layout.Group align="center" justify={alignContent} space="xs">
            <Text>{pickup}</Text>
            <Icon name="arrow-right" />
            <Text>{delivery}</Text>
          </Layout.Group>
          <QuoteSubmitSubTotal
            quoteAccessorials={quoteAccessorials}
            accessorialCharges={accessorialCharges}
            flatRate={flatRate}
          />
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.ActionConfirm onConfirm={onConfirm}>Confirm</Dialog.ActionConfirm>
      <Dialog.ActionCancel onCancel={onCancel}>Cancel</Dialog.ActionCancel>
    </Dialog>
  )
}
